import React, { useContext, useState } from 'react';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import { Alert, Button, Label } from 'edozvola-frontend-lib/dist/ui';
import LocationPermitComplianceTable from 'app/edozvola/cases/location-permit-compliance/location-permit-compliance-table';
import LocationPermitComplianceAddForm from 'app/edozvola/cases/location-permit-compliance/location-permit-compliance-add-form';
import { FormikProvider, useFormik } from 'formik';
import FormikValueObserver from 'app/shared/formik-observer/formik-observer';
import { Col, Row } from 'reactstrap';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { ToggleWithLabels } from 'edozvola-frontend-lib/dist/ui/components/toggle-with-labels';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  fetchLocationPermitComplianceDataQuery, updateLocationPermitComplianceDataQuery
} from 'app/edozvola/cases/location-permit-compliance/service/location-permit-compliance.queries';
import { initialLocationPermitComplianceModel } from './model/location-permit-compliance.model';
import { getCaseContext } from 'app/shared/util/context-util';

const LocationPermitCompliance = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [locationPermit, setLocationPermit] = useState<string | null>(null);
  const { sidebarItemPair } = getCaseContext();
  const dispatch = useDispatch();

  const {data: locationPermitComplianceData, isLoading: locationPermitComplianceDataLoading} = fetchLocationPermitComplianceDataQuery(uuid)

  const formik = useFormik({
    initialValues: locationPermitComplianceData || initialLocationPermitComplianceModel,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: values => saveLocationPermitComplianceData(values)
  })

  const {mutate: saveLocationPermitComplianceData, isPending: savingLocationPermitComplianceData} = updateLocationPermitComplianceDataQuery(uuid)

  return (
    <>
      <FormikProvider value={formik}>
        <FormikValueObserver
          onChange={dirty => {
            if (dirty.dirty) {
              dispatch(setFormChanged(true));
            } else {
              dispatch(initCaseFormChange());
            }
          }}
        />
        <Row>
          <Col md={3}>
            <Label labelText={'Završni akt se izdaje temeljem lokacijske dozvole'} />
            <ToggleWithLabels
              trueLabel="DA"
              falseLabel="NE"
              checked={formik.values.finalActBasedOnLocationPermit}
              onChange={e => formik.setFieldValue('finalActBasedOnLocationPermit', e.target.checked)}
              disabled={sidebarItemPair?.readOnly}
            />
          </Col>
        </Row>
        {formik.dirty && !locationPermitComplianceData?.finalActBasedOnLocationPermit && formik.values.finalActBasedOnLocationPermit && (
          <Row>
            <Col md={6}>
              <Alert color="warning">Potrebno je prvo spremiti izmjenu na kartici da biste mogli dodati akte!</Alert>
            </Col>
          </Row>
        )}
        <hr />
        <div className={'form-header mb-3'}>Lokacijska dozvola</div>
        <div className={'d-flex justify-content-between flex-row-reverse'}>
          {!sidebarItemPair?.readOnly && (
            <Button
              label="Dodaj akt"
              color="info"
              size="lg"
              prependIcon={'plus'}
              onClick={() => setLocationPermit('')}
              disabled={
                (formik.dirty && !locationPermitComplianceData?.finalActBasedOnLocationPermit && formik.values.finalActBasedOnLocationPermit) || !formik.values.finalActBasedOnLocationPermit
              }
            />
          )}
        </div>
        <div className={'mt-3'}>
          <LocationPermitComplianceTable
            onRowClick={(idLocationPermitComplianceMap: string) => setLocationPermit(idLocationPermitComplianceMap)}
            editLocationPermitComplianceDisabled={
              (formik.dirty && !locationPermitComplianceData.finalActBasedOnLocationPermit && formik.values.finalActBasedOnLocationPermit) ||
              !formik.values.finalActBasedOnLocationPermit
            }
          />
        </div>
        {locationPermit !== null && (
          <LocationPermitComplianceAddForm onCloseCallback={() => setLocationPermit(null)} idLocationPermitComplianceMap={locationPermit} />
        )}
        {!sidebarItemPair?.readOnly && (
          <div className={'case-save-button'}>
            <Button
              label={'Spremi'}
              size={'lg'}
              disabled={!formik.dirty || !formik.isValid}
              isLoading={savingLocationPermitComplianceData}
              color={'info'}
              onClick={() => formik.handleSubmit()}
            />
          </div>
        )}
      </FormikProvider>
    </>
  );
};

export default LocationPermitCompliance;
